function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import DataTypes from "./data-types";
import { downloadTemplate, PRODUCT_COLUMNS, PRODUCT_SPEC_URL } from "../../functions/csv-templates";
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onDownloadTemplate", event => {
      downloadTemplate("product-template.csv", PRODUCT_COLUMNS);
    });
    _defineProperty(this, "onDownloadSpec", event => {
      window.open(PRODUCT_SPEC_URL, "_blank", "noopener");
    });
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "Manual File Upload"), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, "Data types you can use:"), /*#__PURE__*/React.createElement(DataTypes, null), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadTemplate
    }, "Download Template"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadSpec
    }, "Download Product Spec"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MDCFileUpload, {
      singleFileUpload: true,
      postUrl: this.props.postUrl,
      onBeforeUpload: this.props.onBeforeUpload,
      onUploadError: this.props.onUploadError,
      onUploadComplete: this.props.onUploadComplete,
      onUploadProgressComplete: this.props.onUploadProgressComplete,
      ref: ref => this.upload = ref,
      accept: ".csv,.txt"
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("button", {
      className: "ui-button secondary small icon span-margin",
      onClick: this.props.onUploadBack
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_left"), "Back"));
  }
}